"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _userInfo = require("hub-http/userInfo");

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _link = require("../../constants/link");

var _iterables = require("../../utils/iterables");

var _link2 = require("../../utils/link");

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.links.linkTypes." + _link.LinkTypes.MEETING + "." + suffix;
};

var MeetingLinkField =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(MeetingLinkField, _PureComponent);

  function MeetingLinkField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MeetingLinkField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MeetingLinkField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleChange = function (_ref) {
      var value = _ref.target.value;

      _this.props.onChange({
        url: value.options.url,
        meetingName: value.options.label
      });
    };

    _this.fetchMeetingLinks = function (input, callback) {
      _this.props.fetchMeetings(input).then(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
            meetings = _ref3[0],
            users = _ref3[1];

        if (!_this.mounted) return;
        var idToNameMap = {};
        users.forEach(function (user) {
          return idToNameMap[user.id] = (0, _link2.formatUserName)(user);
        });
        var rawOptions = meetings.map(function (meeting) {
          var meetingName = meeting.name || _I18n.default.text(i18nKey('defaultName'), {
            user: idToNameMap[meeting.userId]
          });

          return {
            userId: meeting.userId,
            text: meetingName,
            value: meeting.link,
            help: meeting.link,
            options: {
              label: meetingName,
              url: meeting.link
            },
            id: meeting.id
          };
        });
        var optionsGrouped = (0, _iterables.groupBy)(function (option) {
          return option.userId;
        }, rawOptions);
        var meetingList = [];
        Object.keys(optionsGrouped).forEach(function (userId) {
          meetingList.push({
            text: idToNameMap[userId] || _I18n.default.text(i18nKey('userNotFound')),
            options: optionsGrouped[userId].sort(_link2.alphabeticalSort),
            userId: Number(userId)
          });
        });

        if (!meetingList.length) {
          meetingList.push({
            text: _I18n.default.text(i18nKey('noMeetingsTitle')),
            disabled: true,
            help: _react.default.createElement(_UILink.default, {
              href: (0, _link2.getSetupMeetingLinkUrl)(),
              external: true
            }, _I18n.default.text(i18nKey('noMeetingsHelp')))
          });
        } else {
          meetingList.sort((0, _link2.getAlphabeticalSortPrioritizingUser)(_this.userId));
        }

        callback(null, {
          options: meetingList
        });
      });
    };

    return _this;
  }

  (0, _createClass2.default)(MeetingLinkField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.userId) {
        this.userId = this.props.userId;
      } else {
        try {
          var _userInfoSync = (0, _userInfo.userInfoSync)(),
              user = _userInfoSync.user;

          this.userId = user.user_id;
        } catch (error) {// DO NOTHING - all this means is that we cannot prioritize
          // the current user in the sorted meeting link list
        }
      }

      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          dropdownClassName = _this$props.dropdownClassName;
      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey('label')),
        className: "m-top-0"
      }, _react.default.createElement(_UISelect.default, {
        dropdownClassName: dropdownClassName,
        searchable: true,
        filterOptions: true,
        value: url,
        loadOptions: this.fetchMeetingLinks,
        onSelectedOptionChange: this.handleChange,
        placeholder: _I18n.default.text(i18nKey('placeholder'))
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        userId: _react.PropTypes.number,
        fetchMeetings: _react.PropTypes.func.isRequired,
        onChange: _react.PropTypes.func.isRequired,
        url: _react.PropTypes.string,
        dropdownClassName: _react.PropTypes.string
      };
    }
  }]);
  return MeetingLinkField;
}(_react.PureComponent);

exports.default = MeetingLinkField;
module.exports = exports.default;